import { RootState } from '../store';

export const selectSkillOptions = (state: RootState) => state.skill.skillOptions;

export const selectSkillOptionsRequestStatus = (state: RootState) => state.skill.skillOptionsRequestStatus;
